export default __webpack_public_path__ + "static/media/change_pass_check_ok.c4595014.svg";